<template src="./paladin-property-preset.html"></template>

<script>
import Vue from 'vue'

// import { PaladinLimit, PaladinPersonLookup } from '@paladin/core-components'

import PaladinPropertyPresetItem from './paladin-property-preset-item'

import _ from 'lodash'

export default {
  components: { PaladinPropertyPresetItem },
  props: { 
    preset: {
      type: Object,
      required: false,
      default: null,
    },
    showsave:{
      type: Boolean,
      required: false,
      default: true,
    }
  },
  data() {
    return {
      payload: [],
      optionValue: null,
      newPropertyName: '',
      store: [],
    }
  },
  computed: {
  },
  watch: {
    preset: function() {
      this.init()
    },
  },
   created: function() {
  },
  mounted() {
    this.$nextTick(function() {
      this.init()
    })
  },
  methods: {
    init() {

      this.payload = [];
      this.store = []

      if(this.preset)
      {
        let preset = this.preset
        let payload = this.payload
        let generateUUID = this.generateUUID

        Object.keys(preset).forEach(function(key) {
          Vue.set(preset[key], 'id', generateUUID())
          Vue.set(preset[key], 'key', key)
          payload.push(preset[key])
        });

        this.store = _.clone(this.payload, true)
      }
    },
    update(presetItem)
    {
       var match = this.store.find(function(element) {
        return element.id === presetItem.id
      });

      if(match)
      {
        var index = this.store.indexOf(match);

        this.store[index] = presetItem
        this.payload[index] = presetItem
      }
    },
    addField()
    {
      if(!this.newPropertyName)
      {
        this.$toast('You must provide a name for the new property', 'error')
        return
      }

      let _newPropertyName = this.newPropertyName

      var match = this.payload.find(function(element) {
        return element.key === _newPropertyName
      });

      if(match)
      {
         this.$toast('A property with that name already exists', 'error')
         return
      }

      // if(this.payload[this.newPropertyName])
      // {
      //   this.$toast('A property with that name already exists', 'error')
      //   return
      // }

//      Vue.set(this.payload, this.newPropertyName, { type: 'text', isMandatory: false, order: 0 })

      var item = { id: this.generateUUID(), key: this.newPropertyName, type: 'text', isMandatory: false, order: 0, options: [] }

      this.store.push(item)
      this.payload.push(item)

      this.newPropertyName = ''
    },
    removeField(id)
    {
      var match = this.payload.find(function(element) {
        return element.id === id
      });

      if(match)
      {
        var index = this.payload.indexOf(match);

        this.store.splice(index, 1)
        this.payload.splice(index, 1)
      }
    },
       generateUUID() { // Public Domain/MIT https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    var d = new Date().getTime()// Timestamp
    var d2 = (performance && performance.now && (performance.now()*1000)) || 0// Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16// random number between 0 and 16
        if(d > 0){// Use timestamp until depleted
            r = (d + r)%16 | 0
            d = Math.floor(d/16)
        } else {// Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0
            d2 = Math.floor(d2/16)
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    });
    },
    save()
    {
      var ret = {}

      if(this.payload)
      {
        this.payload.forEach(item => {
          var obj = _.cloneDeep(item)

          var key = obj.key

          Vue.delete(obj, 'id')
          Vue.delete(obj, 'key')

          Vue.set(ret, key, obj)
        })
      }

      this.$emit('save', ret)
    }
  },
}
</script>

<style lang="scss"></style>
